import { supportsNotifications } from "./util";

export class PushNotifications {

   constructor(app) {
      this.app = app;
      this.subscription = false;
      this.vapidPublicKey = 'BAubH_QEGazNN2YGZcQuQQPZ8JR5F1ynTju3e4u5uQhzxxEwmw_XBVmiq_TU1q-jukaygON9PEpOghCQAT0c-0M';
      this.init();
   }

   /**
    * Initialisiert das PushNotification-Objekt.
      Überwacht Notification-Statusänderungen und informiert den Server über subscriptions, die registriert oder gelöscht werden müssen
   */
   async init() {
      
      if (!supportsNotifications()) return;

      // aktuelle subscription ermitteln
      const registration = await navigator.serviceWorker.ready;
      this.subscription = await registration.pushManager.getSubscription();

      // permission change überwachen
      const notificationPermission = await navigator.permissions.query({name:'notifications'});
      notificationPermission.onchange = async () => {

         // neue permission: subscription erstellen und dem Server mitteilen
         if (Notification.permission === 'granted') {
            const reg = await navigator.serviceWorker.ready;
            this.subscription = await reg.pushManager.subscribe({
               userVisibleOnly: true,
               applicationServerKey: PushNotifications.urlBase64ToUint8Array(this.vapidPublicKey),
            });
            JSON.stringify(this.subscription);
            this.app.dm.sinRequest({ action: 'usr-push-subscription-save', subscription: this.subscription });
         }

         // permission gelöscht: dem Server zu löschende subscription mitteilen
         else {
            if (this.subscription) {
               this.app.dm.sinRequest({ action: 'usr-push-subscription-delete', subscription: this.subscription });
            }
         }

      }
   }

   async requestPermission() {
      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
         const reg = await navigator.serviceWorker.ready;
         this.subscription = await reg.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: PushNotifications.urlBase64ToUint8Array(this.vapidPublicKey),
         });
         logger.message(JSON.stringify(this.subscription));
         this.app.dm.sinRequest({ action: 'usr-push-subscription-save', subscription: this.subscription });
      }
   }

   static urlBase64ToUint8Array(value) {
      const padding = '='.repeat((4 - (value.length % 4)) % 4);
      const base64 = (value + padding).replace(/-/g, '+').replace(/_/g, '/');
      const rawData = atob(base64);
      return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
   }

}